import { DASHBOARD_LINK } from '@components/Router/constants'
import {
  BadgeAccessory,
  DropdownMenu,
  DropdownMenu as Menu,
} from '@octopus-do/octopus-storybook'
import {
  Key,
  Plug,
  Receipt,
  Spymode,
  SquareUser,
  User,
} from '@octopus-do/octopus-storybook/icons'
import { PERSONAL_WORKSPACE_ID } from '@store/reducers/dashboard/constants'
import type React from 'react'

import { PUBLIC_API_ENABLED } from '@/constants/env'
import { useAuth, useFeatureFlags } from '@/hooks'
import { getBadgeType } from '@/utils'
import { UserTeams } from './UserTeams'

interface Props {
  isSpyMode: boolean
}

export const UserMenuContent: React.FC<Props> = ({ isSpyMode }) => {
  const {
    viewers: { isAbleToSetSpyMode },
  } = useFeatureFlags()
  const { emailAddress, fullName, planId } = useAuth()

  const type = getBadgeType(planId)

  return (
    <>
      <DropdownMenu.ContentItem description={emailAddress} title={fullName} />
      <Menu.Divider />
      <Menu.Link
        icon={User}
        title="My projects"
        to={`${DASHBOARD_LINK}/${PERSONAL_WORKSPACE_ID}`}
      >
        <BadgeAccessory type={type} />
      </Menu.Link>
      <UserTeams />
      <Menu.Divider />
      {isAbleToSetSpyMode && (
        <Menu.Switch
          icon={Spymode}
          id="spy_mode"
          on={isSpyMode}
          title="Spy mode"
        />
      )}
      <Menu.Link icon={SquareUser} title="Account" to="/account" />
      {PUBLIC_API_ENABLED && (
        <Menu.Link icon={Key} title="MCP, API keys" to="/api" />
      )}
      <Menu.Link icon={Receipt} title="Subscription" to="/subscription" />
      <Menu.Button icon={Plug} id="integrations" title="Integrations" />
      <Menu.Divider />
      <Menu.Button id="about" title="About" />
      <Menu.Button id="pricing" title="Pricing" />
      <Menu.Button danger id="logout" title="Log out" />
    </>
  )
}
